import { defineComponent, openBlock, createElementBlock, createElementVNode, Fragment, renderList, toDisplayString } from "vue";
const _hoisted_1 = {
  "aria-labelledby": "tech-specs-label",
  class: "tech-specs"
};
const _hoisted_2 = {
  class: "tech-specs__header"
};
const _hoisted_3 = {
  class: "tech-specs__cell"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TechnicalSpecs",
  props: {
    techSpecs: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("table", _hoisted_1, [createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.techSpecs, (techSpec) => {
        return openBlock(), createElementBlock("tr", {
          key: techSpec.name,
          class: "tech-specs__row"
        }, [createElementVNode("th", _hoisted_2, toDisplayString(techSpec.name), 1), createElementVNode("td", _hoisted_3, [(openBlock(true), createElementBlock(Fragment, null, renderList(techSpec.values, (value) => {
          return openBlock(), createElementBlock("p", {
            key: value,
            class: "tech-specs__value"
          }, toDisplayString(value), 1);
        }), 128))])]);
      }), 128))])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TechnicalSpecs2.mjs.map
